import Map from './v3';

export default Map